import Image from "next/image"
import Heading from "~/componentsDS/Typography/Heading"

type LabReviewCardProps = {
    alt?: string
}

const LabReviewCard = ({ alt = "Inner Balance app showing dose adjustment" }: LabReviewCardProps) => {
    return (
        <div className="relative h-[450px] overflow-hidden rounded-[16px] bg-[linear-gradient(180deg,_#19223D_2.38%,_#2A3966_39.12%,_#A9B9E5_161.17%)] md:h-[554px] w-full px-8 md:px-12 pt-3 md:pt-12">
            <Heading
                as="h3"
                font="featureDisplay"
                weight="400"
                className="
                    relative z-[1] pt-5 text-center
                    text-[28px] !leading-[1.1] text-pureWhite
                "
            >
                <>Lab review and <br />dose adjustments if needed</>
            </Heading>
            <div
                className="
                    relative z-[1] mx-auto mt-8 flex justify-center
                    md:px-0 md:mt-[40px]
                "
            >
                <div
                    className="
                        relative rounded-[24px] border border-white/90
                        bg-white/10 px-4
                        shadow-[0_0_45px_rgba(255,255,255,0.12)]
                        md:rounded-[20px] md:px-2
                    "
                >
                    <Image
                        src="https://res.cloudinary.com/dirscuuhp/images/f_svg,q_auto/fl_sanitize/v1776332598/managing-stats-modified/managing-stats-modified.svg"
                        alt={alt}
                        width={420}
                        height={320}
                        sizes="(max-width: 768px) 80vw, 420px"
                        className="
                            pointer-events-none md:h-auto
                            w-full max-w-[420px] object-contain
                        "
                    />
                </div>
            </div>
        </div>
    )
}

export default LabReviewCard
